const livestocks =
{
    helmet :
    {
        title : 'Élevages' ,
        metas : []
    }
};

export default livestocks ;